
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBundle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.846 6h20.308c.467 0 .846.358.846.8v2.4c0 .442-.379.8-.846.8H5.846C5.38 10 5 9.642 5 9.2V6.8c0-.442.379-.8.846-.8zM25 10v14.737c0 .697-.366 1.263-.818 1.263H7.818C7.366 26 7 25.434 7 24.737V10h18z",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.187 20.01 2.133 1.283c.273.165.612-.08.53-.382l-.616-2.304a.342.342 0 0 1 .12-.357l1.914-1.513c.251-.199.122-.595-.201-.615l-2.5-.154a.355.355 0 0 1-.306-.215l-.932-2.23a.352.352 0 0 0-.329-.215.352.352 0 0 0-.33.215l-.931 2.23a.355.355 0 0 1-.307.215l-2.499.154c-.323.02-.452.416-.2.615l1.913 1.513a.342.342 0 0 1 .12.357l-.572 2.137c-.097.363.31.656.636.459l1.983-1.194a.363.363 0 0 1 .374 0z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.44
}))));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M5.846 6h20.308c.467 0 .846.358.846.8v2.4c0 .442-.379.8-.846.8H5.846C5.38 10 5 9.642 5 9.2V6.8c0-.442.379-.8.846-.8zM25 10v14.737c0 .697-.366 1.263-.818 1.263H7.818C7.366 26 7 25.434 7 24.737V10h18z\" stroke=\"#000\" stroke-width=\"2\"/>\r\n        <path d=\"m16.187 20.01 2.133 1.283c.273.165.612-.08.53-.382l-.616-2.304a.342.342 0 0 1 .12-.357l1.914-1.513c.251-.199.122-.595-.201-.615l-2.5-.154a.355.355 0 0 1-.306-.215l-.932-2.23a.352.352 0 0 0-.329-.215.352.352 0 0 0-.33.215l-.931 2.23a.355.355 0 0 1-.307.215l-2.499.154c-.323.02-.452.416-.2.615l1.913 1.513a.342.342 0 0 1 .12.357l-.572 2.137c-.097.363.31.656.636.459l1.983-1.194a.363.363 0 0 1 .374 0z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.44\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bundle.22aff28d26cebfc5ac28c1b2b9d7467f.svg"),
        {
          React: SvgBundle,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      